import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@teko/ds-desktop';
import { E as EnhancedImage } from './EnhancedImage-5956213c.js';

const SmallImage = ({ image, isActive, extra, onClick, onMouseEnter, }) => {
    return (jsxs(Wrapper, Object.assign({ isActive: isActive, onClick: onClick, onMouseEnter: onMouseEnter }, { children: [jsx(EnhancedImage, { src: image.src, alt: image.alt, objectFit: "contain", borderRadius: 4, width: "50px", height: "50px" }, void 0), extra && jsx(Extra, { children: extra }, void 0)] }), void 0));
};
const Wrapper = styled.div(({ isActive, theme }) => `
  border-radius: 4px;
  border: 1px solid ${isActive ? theme.colors.primary500 : 'transparent'};
  position: relative;
  cursor: pointer;
  width: 50px;
  height: 50px;
  overflow: hidden;
`);
const Extra = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export { SmallImage as S };
